import React from "react";
import { X, MapPin, Clock, Timer, Coins, Lightbulb } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

function formatDuration(min) {
  if (!min || min <= 0) return null;
  const h = Math.floor(min / 60);
  const m = min % 60;
  if (h && m) return `~${h}h${String(m).padStart(2, "0")}`;
  if (h) return `~${h}h`;
  return `~${m}min`;
}

export const ActivityPopup = ({ point, jourNumero, couleur, onClose }) => {
  const duree = formatDuration(point.duree_minutes);
  const prix = point.prix_euros;
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    point.google_maps_query || `${point.titre} ${point.lieu}`
  )}`;

  return (
    <div className="voyage-popup-inner" style={LORA} data-testid="activity-popup">
      <button
        onClick={onClose}
        className="voyage-popup-close"
        aria-label="Fermer"
        data-testid="activity-popup-close"
      >
        <X size={15} strokeWidth={2} />
      </button>

      {/* Header */}
      <div className="flex items-start gap-2 pr-5">
        <span style={{ fontSize: "22px", lineHeight: 1 }}>{point.icone || "📍"}</span>
        <div className="min-w-0">
          <p
            className="text-[14px] leading-tight text-[#2B2623]"
            style={{ fontFamily: "'Lora', Georgia, serif", fontWeight: 700 }}
          >
            {point.titre}
          </p>
          <span
            className="inline-block mt-1 text-[10px] text-white px-2 py-0.5 rounded-full"
            style={{ backgroundColor: couleur, letterSpacing: "0.03em" }}
          >
            Jour {jourNumero}
          </span>
        </div>
      </div>

      {/* Body */}
      <div className="mt-2.5 space-y-1.5 text-[12px] text-[#5C554E]">
        {point.lieu && (
          <div className="flex items-center gap-1.5">
            <MapPin size={12} strokeWidth={1.6} className="text-[#9A8F86] flex-shrink-0" />
            <span className="truncate">{point.lieu}</span>
          </div>
        )}
        {point.heure_debut && (
          <div className="flex items-center gap-1.5">
            <Clock size={12} strokeWidth={1.6} className="text-[#9A8F86] flex-shrink-0" />
            <span>{point.heure_debut}</span>
          </div>
        )}
        {duree && (
          <div className="flex items-center gap-1.5">
            <Timer size={12} strokeWidth={1.6} className="text-[#9A8F86] flex-shrink-0" />
            <span>{duree}</span>
          </div>
        )}
        {prix > 0 && (
          <div className="flex items-center gap-1.5">
            <Coins size={12} strokeWidth={1.6} className="text-[#9A8F86] flex-shrink-0" />
            <span>~{prix}€/pers</span>
          </div>
        )}
        {prix === 0 && (
          <span className="inline-block text-[10px] text-[#7B9E87] border border-[#7B9E87]/40 px-1.5 py-0.5 rounded-full">
            Gratuit
          </span>
        )}
        {point.note && (
          <div className="flex items-start gap-1.5 pt-0.5">
            <Lightbulb size={12} strokeWidth={1.6} className="text-[#C17F59] flex-shrink-0 mt-0.5" />
            <span className="italic text-[#9A8F86]">{point.note}</span>
          </div>
        )}
      </div>

      {/* Footer */}
      <a
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="voyage-popup-maps-btn"
        data-testid="activity-popup-maps-link"
      >
        Ouvrir dans Maps 🗺️
      </a>
    </div>
  );
};
